import { defineMessages } from 'react-intl';

export const messages = defineMessages({
   wikiLink: {
    id: 'announcements.wikiLink',
    defaultMessage: 'Wiki Link'
  },
  dontShowAgain: {
    id: 'announcements.dontShowAgain',
    defaultMessage: "Don't show this again"
  },
  ok: {
    id: 'announcements.ok',
    defaultMessage: 'OK'
  },
  close: {
    id: 'announcements.close',
    defaultMessage: 'Close'
  },
  noNewAnnouncements: {
    id: 'announcements.noNewAnnouncements',
    defaultMessage: 'No New Announcements!'
  },
  previous: {
    id: 'announcements.previous',
    defaultMessage: 'Previous'
  },
  next: {
    id: 'announcements.next',
    defaultMessage: 'Next'
  }
});

